import { render } from "./About.vue?vue&type=template&id=7efec9c8"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7efec9c8&lang=stylus"

import exportComponent from "/Users/anvaka/projects/vs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__